module.exports = __webpack_public_path__ + "img/screenshot_1.f665dd07.png";